const Filter: React.FC = ({ children }) => {
  return (
    <div
      className="flex border border-gray-300 hover:border-orange-300 rounded bg-coolGray-50
   focus-within:border-orange-300 focus-within:ring-1 focus-within:ring-orange-300 focus-within:bg-white"
    >
      {children}
    </div>
  )
}

export default Filter
